import React, { useState, useEffect } from "react";
import Navbar from "./components/Navbar/Navbar";
import Intro from "./components/Intro/Intro";
import "./App.css";
import Services from "./components/Services/Services";
import Experience from "./components/Experience/Experience";
import Works from "./components/Works/Works";
import Portfolio from "./components/Portfolio/Portfolio";
import Testimonial from "./components/Testimonials/Testimonial";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import { themeContext } from "./Context";
import { useContext} from "react";
import Sidebar from "./components/Sidebar/Sidebar";
import Burger from "./components/Burger/Burger";
import Top from 'bootstrap-icons/icons/arrow-up.svg';


function App() {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  const [sidebar,setSidebar] = useState(false);

  const toggleSidebar = () => {
    setSidebar((prevState) => !prevState)
  }

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);

  return (
    <>
      <div
        className="App"
        style={{
          background: darkMode ? "black" : "",
          color: darkMode ? "white" : "",transition:'all .4s linear'
        }}
      >
        <Navbar></Navbar>
        <Burger openSidebar={toggleSidebar}></Burger>
        <Sidebar sidebar={sidebar}></Sidebar>
        <Intro></Intro>
        <Services></Services>
        <Experience></Experience>
        <Works></Works>
        <Portfolio></Portfolio>
        <Testimonial></Testimonial>
        <Contact></Contact>
        <Footer></Footer>

        <button
        onClick={() => {
          window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
        }}
        style={{
          position: 'fixed',
          padding: '1rem',
          fontSize: '20px',
          bottom: '45px',
          right: '20px',
          width:'1rem',
          height:'1rem',
          backgroundColor: '#5F8700',
          textAlign: 'center',
          outline:'none',
          border:'none',
          borderRadius:'10px',
          zIndex:'7',
        }}
      >
        <img src={Top} alt="" 
        style={{
          position:'absolute',
          right:'25%',
          top:'25%',
        }}
        />
      </button>
      </div>
    </>
  );
}

export default App;
